import React from 'react';
import { connect } from 'react-redux';
import LeftMenuV2 from './left-menu-v2';
import { dispatchMenuState } from './left-menu-actions';

const mapStateToProps = (state, ownProps) => {
	return {
		compareProducts: state.compare.products,
		compareModalOpen: state.compare.modal,
		isDragging: state.compare.isDragging,
		customFields: ownProps.customFields || state.slugInfo.components.leftMenu,
		leftMenuActive: state.leftMenu.active
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		dispatchMenuState: value => dispatch(dispatchMenuState(value))
	}
};

class ToggleLeftMenuWrapper extends React.PureComponent {
	constructor(props) {
		super(props)
		this.setMenuState(props);
	}

	componentDidUpdate(prevProps){
		const { defaultExpanded } = this.props;
		if(prevProps.defaultExpanded !== defaultExpanded && defaultExpanded){
			this.setMenuState(this.props);
		}
	}

	setMenuState(props){
		if(props.defaultExpanded){
			const { dispatchMenuState, leftMenuActive } = props;
			dispatchMenuState && !leftMenuActive && dispatchMenuState(true);
		}
	}

	render() {
		const { dispatchMenuState, leftMenuActive, children } = this.props;
		return children ? children({ dispatchMenuState, leftMenuActive }) : null
	}
}

export const ToggleLeftMenu = connect(mapStateToProps, mapDispatchToProps)(ToggleLeftMenuWrapper);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LeftMenuV2);
